// A category rendered as "name (external_id)" — shared by the autocomplete
// options and the pre-selected value so both read the same. Falls back to just
// the name when there is no external id (e.g. a cleared/optimistic value).
export const formatCategoryLabel = (category?: {
  name?: string;
  external_id?: number;
}): string => {
  if (!category) return '';
  return category.external_id
    ? `(${category.external_id}) ${category.name ?? ''}`
    : category.name ?? '';
};
